<template>
  <v-card elevation="0" class="ga-6">
    <template v-slot:text>
      <v-data-table
        :headers="headers"
        :items="items"
        :hover="true"
        :loading="userStore.loading.value"
        item-value="personId"
        hide-default-footer
      >
        <template v-slot:item.name="{ item }">
          <p v-if="props.membershipOptionsLink">
            {{ new PersonNameInfoClass(item).getFullName() }}
          </p>
          <v-btn @click="personSelected(item)" v-else class="pa-0 ga-0 ma-0">
            {{ new PersonNameInfoClass(item).getFullName() }}
          </v-btn>
        </template>

        <template v-slot:item.dob="{ item }">
          <p>{{ formatDateNY(item.dob) }}</p>
        </template>

        <template v-slot:item.card="{ item }">
          <p>{{ activeCardText(item) }}</p>
        </template>

        <template v-slot:item.membership="{ item }">
          <p>{{ activeMembershipText(item) }}</p>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="!hasActiveMembership(item)"
            icon="mdi-ticket-account"
            :to="{ name: 'youth-memberships', params: { id: item.personId } }"
          />
          <v-btn
            icon="mdi-account-details"
            title="View profile"
            :to="{
              name: 'Person Profile',
              params: { personId: item.personId },
            }"
          />
          <v-btn icon="mdi-pencil" @click="editChild(item)" />
          <!--v-btn
            icon="mdi-trash-can"
            @click="removeChild(item)"
          /-->
        </template>
      </v-data-table>
    </template>
  </v-card>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import type { PersonMember } from "../../../cbi-generator/generated/dto/PersonMember";
import { PersonNameInfoClass } from "@/api/dto/PersonNameInfo";
import { useUser } from "@/composables/useUser";
import { useUtility } from "@/composables/useUtility";

const emit = defineEmits(["editChild", "removeChild", "personSelectedId"]);

const userStore = useUser();

const children = userStore.currentChildrenRef;

const dialog = ref(false);

const { formatDateNY, formatMembershipLabel } = useUtility();

watch(dialog, () => {
  if (!dialog.value) {
    handleCancel();
  }
});

function hasActiveMembership(item: PersonMember) {
  return !!item.activeMembershipTypeName;
}

function activeMembershipText(item: PersonMember) {
  return formatMembershipLabel(item) ?? "--";
}

function activeCardText(item: PersonMember) {
  return item.activeCardNum ? "Active (" + item.activeCardNum + ")" : "--";
}

const isValid = computed(() => true);

provide("isValid", isValid);

function editChild(person?: PersonMember) {
  emit("editChild", person);
}

function personSelected(person: PersonMember) {
  emit("personSelectedId", person.personId);
}

function removeChild(child: PersonMember) {
  emit("removeChild", child);
}

function handleCancel() {
  //editChild(undefined);
  dialog.value = false;
}

const props = defineProps<{
  membershipOptionsLink?: boolean;
  membershipOptionsAction?: boolean;
}>();

const router = useRouter();

const items = computed(() => children.value);

const headersRaw = [
  { title: "Name", value: "name" },
  { title: "DOB", value: "dob" },
  { title: "Latest Card", value: "card" },
  { title: "Membership Status", value: "membership" },
  { title: "Actions", value: "actions", sortable: false },
];

const headers = computed(() =>
  props.membershipOptionsLink
    ? headersRaw
    : headersRaw.filter((a) => a.title != "Actions"),
);
</script>
